export default {
  MENU_LEFT_SET_STATE: '@menuLeft/MENU_LEFT_SET_STATE',
};
